import { _ as __rest, a as __assign, b as __spreadArray } from './tslib.es6-1ab78651.js';
import React__default from 'react';
import { T as Typography } from './Typography-fe79fc7d.js';

var styles = {"container":"StepProgressBar_container_78263dd1","label":"StepProgressBar_label_78263dd1","stepWrapper":"StepProgressBar_stepWrapper_78263dd1","step":"StepProgressBar_step_78263dd1"};

var StepProgressBar = function (_a) {
    var steps = _a.steps, currentStep = _a.currentStep, label = _a.label, color = _a.color, otherProps = __rest(_a, ["steps", "currentStep", "label", "color"]);
    var _b = React__default.useState(), step = _b[0], setStep = _b[1];
    React__default.useEffect(function () {
        if (step !== currentStep)
            setStep(currentStep);
    }, [currentStep, step]);
    return (React__default.createElement("div", __assign({ className: styles.container, style: { color: color ? color : "--color-ui-action" } }, otherProps),
        React__default.createElement(Typography, { variant: "p", as: "p", className: styles.label, "data-testid": "step-label" }, label ? label : "Step ".concat(currentStep, " of ").concat(steps)),
        __spreadArray([], Array(steps), true).map(function (_, i) { return (React__default.createElement("div", { className: styles.stepWrapper, key: i, "data-testid": "step" },
            React__default.createElement("div", { className: styles.step, style: { width: currentStep > i ? "100%" : 0 } }))); })));
};

export { StepProgressBar as S };
